import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/MoreVert';

class MoreVertIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default MoreVertIcon;
